import { FaGithub, FaInstagram, FaTwitter, FaFacebook } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer
      className={
        'bg-bgContenedorOscuro text-gray-300 flex flex-col justify-center items-center p-3 py-6 md:p-4 md:py-10 h-auto border-t-4 border-borderContenedorOscuro shadow-shadowContenedorOscuro shadow-[0_0_30px_rgba(148,0,211,0.9)]'
      }
    >
      <div className={'text-center mb-3 md:mb-6'}>
        <p className={'mb-2 md:mb-4 font-bold text-xs md:text-base'}>
          &copy; {t('footer.group')}: 404 All In | {t('footer.finalProject')} 2024 | TUDW - UNCO
        </p>
        <ul className="text-xs md:text-base">
          <li>
            <p>Borghese Nicolas FAI-997</p>
          </li>
          <li>
            <p>Irigoyen Joquín FAI-4223</p>
          </li>
          <li>
            <p>La Forgia Floriana FAI-2498</p>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
